import { useState } from "react";
import AllBrokerReferral from "./AllBrokerReferral";       // ✅ NEW
import LabReferral from "./LabReferralbroker";
import IPDReferral from "./IPDReferralbroker";
import OPDReferral from "./OPDReferralbroker";
import PharmacyReferral from "./PharmacyReferralbroker";

const DoctorReferral = () => {
  const [activeMainTab, setActiveMainTab] = useState("doctorReferral");
  // default sub tab is now "all"
  const [activeSubTab, setActiveSubTab] = useState("all");

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <h5 className="card-title mb-0">Broker Accounts</h5>
              </div>

              <div className="card-body">
                {/* Main Tabs */}
                <ul className="nav nav-tabs nav-tabs-custom nav-success mb-3" role="tablist">
                  <li className="nav-item">
                    <a
                      href="#"
                      role="tab"
                      onClick={(e) => { e.preventDefault(); setActiveMainTab("doctorReferral"); }}
                      className={`nav-link ${activeMainTab === "doctorReferral" ? "active" : ""}`}
                    >
                      <i className="ri-user-line me-1 align-bottom"></i>
                      Broker Referral
                    </a>
                  </li>
                </ul>

                <div className="tab-content">
                  {activeMainTab === "doctorReferral" && (
                    <div className="tab-pane active">
                      {/* Inner tabs */}
                      <ul className="nav nav-pills nav-primary mb-3" role="tablist">
                        {/* ✅ NEW: All tab (default) */}
                        <li className="nav-item">
                          <a
                            href="#"
                            role="tab"
                            onClick={(e) => { e.preventDefault(); setActiveSubTab("all"); }}
                            className={`nav-link ${activeSubTab === "all" ? "active" : ""}`}
                          >
                            <i className="ri-apps-2-line me-1 align-bottom"></i>
                            All
                          </a>
                        </li>

                        <li className="nav-item">
                          <a
                            href="#"
                            role="tab"
                            onClick={(e) => { e.preventDefault(); setActiveSubTab("lab"); }}
                            className={`nav-link ${activeSubTab === "lab" ? "active" : ""}`}
                          >
                            <i className="ri-test-tube-line me-1 align-bottom"></i>
                            Lab
                          </a>
                        </li>

                        <li className="nav-item">
                          <a
                            href="#"
                            role="tab"
                            onClick={(e) => { e.preventDefault(); setActiveSubTab("ipd"); }}
                            className={`nav-link ${activeSubTab === "ipd" ? "active" : ""}`}
                          >
                            <i className="ri-hospital-line me-1 align-bottom"></i>
                            IPD
                          </a>
                        </li>

                        <li className="nav-item">
                          <a
                            href="#"
                            role="tab"
                            onClick={(e) => { e.preventDefault(); setActiveSubTab("opd"); }}
                            className={`nav-link ${activeSubTab === "opd" ? "active" : ""}`}
                          >
                            <i className="ri-stethoscope-line me-1 align-bottom"></i>
                            OPD
                          </a>
                        </li>

                        <li className="nav-item">
                          <a
                            href="#"
                            role="tab"
                            onClick={(e) => { e.preventDefault(); setActiveSubTab("pharmacy"); }}
                            className={`nav-link ${activeSubTab === "pharmacy" ? "active" : ""}`}
                          >
                            <i className="ri-medicine-bottle-line me-1 align-bottom"></i>
                            Pharmacy
                          </a>
                        </li>
                      </ul>

                      {/* Inner tab content */}
                      <div className="tab-content">
                        {activeSubTab === "all" && <AllBrokerReferral />}
                        {activeSubTab === "lab" && <LabReferral />}
                        {activeSubTab === "ipd" && <IPDReferral />}
                        {activeSubTab === "opd" && <OPDReferral />}
                        {activeSubTab === "pharmacy" && <PharmacyReferral />}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorReferral;